var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-xs-center"},[_vm._v("Business List")]),_c('v-card',[_c('businesslist')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }